
import {
    UPDATE_RAG_STORE_SUCCESS,
  } from '../actions/types';
  
  const INITIAL_STATE = {
    ragStore: null,
  };
  
  export default function ragStoreReducer (state=INITIAL_STATE, action) {
    switch (action.type) {
      case UPDATE_RAG_STORE_SUCCESS:
        return { ...state, ragStore: action.payload.rag_store };
      default:
        return state;
    }
  };